import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner"; 

@Component({
  selector: 'app-refer-friend',
  templateUrl: './refer-friend.component.html',
  styleUrls: ['./refer-friend.component.css']
})
export class ReferFriendComponent implements OnInit {

  public email:any;
  public referrals_name:any;
  public referrals_email:any
  public referrals_Phone:number;
  public referrals_comments:any;
  // form: FormGroup;
  constructor(private SpinnerService: NgxSpinnerService) { }

  form = new FormGroup({
    ur_name: new FormControl('', Validators.required)
  }); 

  get f(){
    return this.form.controls;
  }

  ngOnInit(): void {
    console.log(this.form.value);
  }

  submit()
  {
    console.log(this.form.value);
  }
}
